const TEXTS = {
    welcomeAcceptAllButtonText: 'Przejdź do serwisu',
    welcomeCustomChoicesButtonText: 'Ustawienia zaawansowane',
    welcomeRejectAllButtonText: 'Nie wyrażam zgody',
    customChoicesAcceptAllButtonText: 'Zezwolenie na wszystkie',
    customChoicesRejectAllButtonText: 'Odrzucenie wszystkich',
}

const WAIT_TIMEOUT = 30000
const POLL_INTERVAL = 200

const callCmp = (command, parameter) => {
    if (typeof window.__cmp !== 'function') {
        return false
    }

    window.__cmp(command, parameter)

    return true
}

const waitForElement = (root, resolve, callback, timeout = WAIT_TIMEOUT) => {
    const initial = resolve()

    if (initial) {
        callback(initial)

        return
    }

    const observer = new MutationObserver(() => {
        const element = resolve()

        if (!element) {
            return
        }

        observer.disconnect()
        clearTimeout(timer)
        callback(element)
    })

    const timer = setTimeout(() => observer.disconnect(), timeout)

    observer.observe(root, {childList: true, subtree: true})
}

const findCmpBox = () => {
    const wrapper = document.querySelector('#cmpwrapper')
    const wrapperRoot = wrapper?.shadowRoot ?? wrapper

    return wrapperRoot?.querySelector('#cmpbox') ?? document.querySelector('#cmpbox')
}

const waitForCmpBox = (callback, timeout = WAIT_TIMEOUT) => {
    const cmpBox = findCmpBox()

    if (cmpBox) {
        callback(cmpBox)

        return
    }

    const interval = setInterval(() => {
        const element = findCmpBox()

        if (!element) {
            return
        }

        clearInterval(interval)
        clearTimeout(timer)
        callback(element)
    }, POLL_INTERVAL)

    const timer = setTimeout(() => clearInterval(interval), timeout)
}

class CustomizeCMP {
    constructor(cmpBox) {
        this.cmpBox = cmpBox
        this.cmpBox.classList.add('cmpWrapperLoaded')
        this.observer = null
        this.state = {
            isWelcomeScreen: false,
            isCustomChoicesScreen: false,
            isVendorListVisible: false,
        }

        this.checkDisplayedScreen = this.checkDisplayedScreen.bind(this)
        this.handleCustomChoicesScreen = this.handleCustomChoicesScreen.bind(this)

        this.customizeCMP()
    }

    customizeCMP() {
        if (this.observer) {
            return
        }

        this.observer = new MutationObserver(this.checkDisplayedScreen)
        this.observer.observe(this.cmpBox, {attributes: true, subtree: false})

        this.checkDisplayedScreen([])
    }

    checkDisplayedScreen(mutations) {
        if (this.cmpBox.classList.contains('cmpboxclosed')) {
            this.state.isWelcomeScreen = false
            this.state.isCustomChoicesScreen = false

            return
        }

        const isWelcomeScreen = this.cmpBox.classList.contains('cmpboxWelcomeGDPR')
        const isCustomChoicesScreen = this.cmpBox.classList.contains('cmpboxCustomChoices')

        if (isWelcomeScreen && !this.state.isWelcomeScreen) {
            this.state.isWelcomeScreen = true
            this.state.isCustomChoicesScreen = false
            this.handleWelcomeScreen()
        }

        if (isCustomChoicesScreen) {
            const isNewScreen = !this.state.isCustomChoicesScreen

            this.state.isCustomChoicesScreen = true
            this.state.isWelcomeScreen = false
            this.handleCustomChoicesScreen()

            if (isNewScreen && !this.state.isVendorListVisible && this.vendorsListButton) {
                this.vendorsListButton.onclick = () => {
                    this.state.isVendorListVisible = true
                    waitForElement(
                        this.cmpBox,
                        () => this.cmpBox.querySelector('.cmptblbox'),
                        this.handleCustomChoicesScreen,
                    )
                }
            }
        }

        if (mutations.length && !isWelcomeScreen && !isCustomChoicesScreen) {
            this.state.isWelcomeScreen = false
            this.state.isCustomChoicesScreen = false
        }
    }

    createButton(id, classes, text, onClick) {
        const button = document.createElement('span')
        button.classList.add('cmpboxbtnspan')
        button.setAttribute('id', id)

        const innerElement = document.createElement('a')
        innerElement.classList.add('cmpboxbtn', ...classes)
        innerElement.setAttribute('href', '#')
        innerElement.innerText = text

        button.append(innerElement)
        button.onclick = event => {
            event.preventDefault()
            onClick()
        }

        return button
    }

    handleWelcomeScreen() {
        try {
            const purposesWrapper = this.cmpBox.querySelector('.purposes')
            const purposes = this.cmpBox.querySelector('.cmpboxwelcomeprps')
            const policyText = this.cmpBox.querySelector('#custom-policy-text')
            const moreInfoParagraph = this.cmpBox.querySelector('.more > p')
            const moreInfoButton = this.cmpBox.querySelector('.cmptxt_btn_more')

            let rejectAllButton = this.cmpBox.querySelector('.cmpboxbtnno')

            if (moreInfoButton) {
                moreInfoButton.setAttribute('target', '_blank')
            }

            const buttonsWrapper = this.cmpBox.querySelector('.cmpboxbtns')

            if (!rejectAllButton && buttonsWrapper) {
                rejectAllButton = this.createButton(
                    'cmpwelcomebtnno',
                    ['cmpboxbtnno', 'cmptxt_btn_no'],
                    TEXTS.welcomeRejectAllButtonText,
                    () => callCmp('setConsent', 0),
                )

                const acceptAllButton = this.createButton(
                    'cmpwelcomebtnyes',
                    ['cmpboxbtnyes', 'cmptxt_btn_yes'],
                    TEXTS.welcomeAcceptAllButtonText,
                    () => callCmp('setConsent', 1),
                )

                const customChoicesButton = this.createButton(
                    'cmpwelcomebtncustom',
                    ['cmpboxbtncustom', 'cmptxt_btn_settings'],
                    TEXTS.welcomeCustomChoicesButtonText,
                    () => callCmp('showScreenAdvanced'),
                )

                buttonsWrapper.querySelector('#cmpwelcomebtnsave')?.remove()
                buttonsWrapper.querySelector('.cmpmore')?.remove()

                buttonsWrapper.append(customChoicesButton)
                buttonsWrapper.append(acceptAllButton)
            }

            if (purposesWrapper && purposes) {
                purposesWrapper.append(purposes)
            }

            if (policyText && rejectAllButton) {
                policyText.append(rejectAllButton)
            }

            if (moreInfoParagraph && moreInfoButton) {
                moreInfoParagraph.append(moreInfoButton)
            }

            const policyTextSettingsButton = policyText?.querySelector('.cmpboxbtncustom')

            if (policyTextSettingsButton) {
                policyTextSettingsButton.onclick = event => {
                    event.preventDefault()
                    callCmp('showScreenAdvanced')
                }
            }

            this.state.isVendorListVisible = false
        } catch (error) {
            console.error('Error while customizing welcome screen', error)
        }
    }

    handleCustomChoicesScreen() {
        try {
            const boxInner = this.cmpBox.querySelector('.cmpboxinner')
            const content = this.cmpBox.querySelector('.cmptblbox')
            const buttonsWrapper = this.cmpBox.querySelector('.cmpboxbtnscustomchoices')
            const backButton = this.cmpBox.querySelector('.cmptxt_btn_back')
            const acceptAllTextBox = this.cmpBox.querySelector('.cmptxt_btn_yes > span')
            const rejectAllTextBox = this.cmpBox.querySelector('.cmptxt_btn_no > span')

            if (!this.state.isVendorListVisible && content) {
                this.vendorsListButton = content.querySelector('.cmptbl .cmpmorelink')
            }

            if (content && buttonsWrapper) {
                content.append(buttonsWrapper)
            }

            if (boxInner && backButton) {
                boxInner.append(backButton)
            }

            if (acceptAllTextBox) {
                acceptAllTextBox.innerText = TEXTS.customChoicesAcceptAllButtonText
            }

            if (rejectAllTextBox) {
                rejectAllTextBox.innerText = TEXTS.customChoicesRejectAllButtonText
            }
        } catch (error) {
            console.error('Error while customizing custom choices screen', error)
        }
    }
}

const initConsentSettingsLink = () => {
    const cookiesChange = document.getElementById('cookies-change')

    if (!cookiesChange) {
        return
    }

    cookiesChange.addEventListener('click', event => {
        event.preventDefault()

        if (typeof window.cmpmngr !== 'undefined') {
            window.cmpmngr.showCustomChoices()
        }
    })
}

const initCustomizeCMP = () => {
    if (!document.querySelector('script[data-cmp-cdid]')) {
        return
    }

    initConsentSettingsLink()

    waitForCmpBox(cmpBox => new CustomizeCMP(cmpBox))
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomizeCMP)
} else {
    initCustomizeCMP()
}

export {CustomizeCMP}
